import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
export interface iWorkFlowStepListState {
    response: any;
    isLoading: boolean;
    message: string | null;
}
const initialState: iWorkFlowStepListState = {
    response: null,
    isLoading: false,
    message: "",
};

export const workFlowStepListAPI = createAsyncThunk(
    "workFlowStepListAPI",
    async (data: {
        group_name: string;
        library_name: string;
        round: number;
        workflow_name: string;
    }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/workflow/step-list/';
            const response = await axiosInstance.post(`${djangoEndpoint}${pathParam}`, {
                workflow_name: data.workflow_name,
                group_name: data.group_name,
                library_name: data.library_name,
                round: data.round
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const workFlowStepListSlice = createSlice({
    name: "workFlowStepList",
    initialState,
    reducers: {},
    extraReducers: (builder) => {   
        builder
            .addCase(workFlowStepListAPI.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(workFlowStepListAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload;
            })
            .addCase(workFlowStepListAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
            });
    }
});


export default workFlowStepListSlice.reducer;